import { Component, Input } from '@angular/core';
import { DiagnosisForReview } from '../../models/diagnosis.model';

import { HistoricDiagnoseDetailRowComponent } from './historic-diagonose-details-row/historic-diagnose-detail-row.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-historic-diagnoses-details',
  templateUrl: './historic-diagnoses-details.component.html',
  imports: [HistoricDiagnoseDetailRowComponent, TranslateModule]
})
export class HistoricDiagnosesDetailsComponent {
  @Input() diagnoses: DiagnosisForReview[];
}
